import React, { useState, useEffect } from 'react';

const SequenceShow = ({ children }) => {
  const [index, setIndex] = useState( children.length-1 );
  const [newChild, setNewChild] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex( (prevIndex) => {
        return prevIndex === 0 ? children.length-1 : prevIndex-1
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [children]);

  useEffect( ()=>{
    setNewChild( children[index] )
  }, [index])

  return (
    <strong>{newChild}</strong>
  );
};

export default SequenceShow;